import { render, staticRenderFns } from "./Courtigo.vue?vue&type=template&id=208c31ed&scoped=true&"
import script from "./Courtigo.vue?vue&type=script&lang=js&"
export * from "./Courtigo.vue?vue&type=script&lang=js&"
import style0 from "./Courtigo.vue?vue&type=style&index=0&id=208c31ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208c31ed",
  null
  
)

export default component.exports